module.exports = __webpack_public_path__ + "media/app_search/FreeTrialExtend/images/clients/client-icon-php-f68c81c68ddf895530e184a18f821d5f.svg";